
import { useEffect } from "react";
import { logRender } from "@/utils/debugLogger";

/**
 * Hook to force re-render on specific property changes for movie cards
 */
export const useForceRender = (
  movieTitle: string,
  viewMode: string,
  pendingActions: any[],
  currentTab?: string,
  shouldDebug = false,
  hasPendingAction = false
) => {
  // Force re-render on viewMode or pendingActions changes
  useEffect(() => {
    // This effect ensures that we re-evaluate the component when viewMode, 
    // pending actions, or current tab changes
    
    // Log only for debug movies
    if (shouldDebug) {
      logRender("useMovieCard: Recalculating state for movie:", movieTitle, {
        viewMode,
        currentTab,
        pendingActionsCount: pendingActions.length
      });
    }
    
    // We'll rely on React's natural re-rendering for changes
    // This effect is primarily for logging and no longer needs an interval
    
    // We don't need the interval here - it was causing unnecessary renders
    // The component will naturally re-render when props change
    
  }, [viewMode, pendingActions, currentTab, movieTitle, shouldDebug, hasPendingAction]);
};
